import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";

function EstimatedAG() {
  // State for API data
  const [dataO, setdataO] = useState([]);
  const [dataI, setdataI] = useState([]);

  // Loading state
  const [loadingA, setLoadingA] = useState(true);
  const [loadingB, setLoadingB] = useState(true);
  const [loadingC, setLoadingC] = useState(true);

  // Error state
  const [errorA, setErrorA] = useState(null);
  const [errorB, setErrorB] = useState(null);
  const [errorC, setErrorC] = useState(null);

  // Sum variables
  const [totalYardavg, setTotalYardavg] = useState(0); // Total sum state
  const [inyardwt, setInYardWt] = useState(0); // State for In Yard Weight
  const [outyardwt, setOutYardWt] = useState(0); // State for Out Yard Weight

  useEffect(() => {
    // Fetch data for Class B (2nd API)
    const fetchdataO = async () => {
      try {
        const response = await fetch(
          "https://webcore.hunzagroupofindustries.com.pk/api/OYardAG"
        );
        if (!response.ok) throw new Error("Failed to fetch data for Class B");
        const result = await response.json();
        console.log("outyardapi:", result);
        setdataO(result);
      } catch (error) {
        setErrorB(error.message);
      } finally {
        setLoadingB(false);
      }
    };

    // Fetch data for Class C (3rd API)
    const fetchdataI = async () => {
        try {
            const response = await fetch(
                "https://webcore.hunzagroupofindustries.com.pk/api/InYardAG"
            );
            if (!response.ok) throw new Error("Failed to fetch data for Class C");
            const result = await response.json();

            // Log the entire response to verify the data
            console.log("INyardapi response:", result);

            // Set the data to state
            setdataI(result);
        } catch (error) {
            setErrorC(error.message);
        } finally {
            setLoadingC(false);
        }
    };


    // Call the fetch functions
    fetchdataI();
    fetchdataO();
  }, []);

  // Update calculations and logging after the data is fetched
  useEffect(() => {
    // Log the fetched data to check the structure
    console.log("dataI:", dataI); // Log the data to inspect

    // Only perform the calculation if the data is available
    if (dataI.length > 0 && dataO.length > 0) {
      // Ensure Totalwt exists in the response
      const inYardAvgCost = parseFloat(dataI[0]?.TotalCost) || 0;
      //console.log("INYard AvgCost:", inYardAvgCost);

      const outYardAvgCost = parseFloat(dataO[0]?.TotalCost) || 0;
      //console.log("OutYard AvgCost:", outYardAvgCost);

      // Check if Totalwt exists, otherwise log a warning
      const fetchedInYardWt = parseFloat(dataI[0]?.TotalWt) || 0 ;

      console.log(fetchedInYardWt);

      if (isNaN(fetchedInYardWt)) {
        console.warn("In Yard Weight (Totalwt) is missing or invalid"+fetchedInYardWt);
      }
      setInYardWt(fetchedInYardWt || 0); // Set the In Yard Weight

      const fetchedOutYardWt = parseFloat(dataO[0]?.TotalWt);
      setOutYardWt(fetchedOutYardWt || 0); // Set the Out Yard Weight
      console.warn("In Yard Weight (Totalwt) "+fetchedOutYardWt || 0);
      // Calculate the total average weight
      const totalYardAvg = (inYardAvgCost+outYardAvgCost)/(inyardwt + outyardwt);
      
      setTotalYardavg(totalYardAvg.toFixed(4)); // Update state with total value
    }
  }, [dataI, dataO, inyardwt, outyardwt]); // Dependencies for effect to run when data changes

  return (
    <div className="container mt-5">
      <h3 className="text-center mb-4">Estimated Avg. Cost of Yard Balance</h3>

      {/* Class B Data (2nd API) */}
      <div className="row">
      <div className="col-md-4">
        </div>
        <div className="col-md-4">
          <div className="card">
            <div className="card-header bg-success text-white">
              <h4>Avg. Cost</h4>
            </div>
            <div className="card-body">
              {loadingB && <div>Loading data for Class B...</div>}
              {errorB && <div className="alert alert-danger">{errorB}</div>}
              {dataO.length > 0 && !loadingB && (
                <div className="table-responsive">
                  <table className="table table-bordered">
                    <thead>
                      <tr>
                        <th>Yard </th>
                        <th className="text-end">Qty</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>In Yard</td>
                        <td className="text-end">{(dataI[0]?.AvgCost || "N/A")}</td>
                      </tr>
                      <tr>
                        <td>Out Yard</td>
                        <td className="text-end">{(dataO[0]?.AvgCost || "N/A")}</td>
                      </tr>
                      <tr>
                        <td><strong>Total Avg Cost </strong></td>
                        <td className="text-end">{totalYardavg}

                            
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              )}
              {!dataO.length && !loadingB && <div>No data available</div>}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EstimatedAG;
